/* eslint-disable no-unused-vars */
import guestService from '../services/guest.service';
import axios from 'axios';
import authHeader from '../services/auth-header';

const API_URL = '/api/v2';

const initialState = { guests: null, guest: null };

export const guests = {
    namespaced: true,
    state: initialState,
    actions: {
        async getGuest({ commit }) {
            const guests = await guestService.getGuest();
            commit('setGuests', guests);
        },

        async getGuestById({ commit }, guestId) {
            const guest = await guestService.getGuestById(guestId);
            commit('setGuest', guest);
        },

        async createPassword() {
            const password = await guestService.createPassword();
            return password; // Rückgabe des generierten Passworts
        },

        async updatePassword({ commit }, { id, password }) {
            const message = await guestService.updatePassword(id, password);
            return message; // Rückgabe der Erfolgsmeldung
        },
    },
    mutations: {
        setGuests(state, guests) {
            state.guests = guests;
        },
        setGuest(state, guest) {
            state.guest = guest;
        },
    },
};